export async function isIosDevice() {
  return false;
}
